import { takeEvery, fork, put, all, call, select } from 'redux-saga/effects';
import {
  GET_VENDORS,
  GET_VENDORS_LIST,
  ADD_VENDOR,
  DELETE_VENDOR,
  EDIT_VENDOR,
  UPDATE_VENDOR,
  GET_VENDOR_RELATIONS,
  GET_VENDOR_PRICE_LOGS,
  GET_VENDORS_LIST_CLIENT,
} from './actionTypes';
import {
  setVendorsList,
  setVendorsListClient,
  setVendors,
  emptyVendor,
  setVendor,
  apiError,
  getVendors as fetchVendors,
  setVendorFilter,
  setVendorRelations,
  getVendorRelations as fetchVendorRelations,
  setVendorRelationFilter,
  getVendorPriceLogs as fetchVendorPriceLogs,
  setVendorPriceLogs,
  setVendorPriceLogsFilter
} from './actions';
import { httpDelete, httpGet, httpPost, httpPut } from '../../utils/http';
import { VENDORS_ENDPOINT, VENDOR_PRICE_LOGS } from '../../config/endPoints';

function* getVendorRelations({ payload: { id } }) {
  try {
    const vendorState = yield select(getVendor);
    let URL = VENDORS_ENDPOINT;
    URL += `/relations/${id}`
    URL += `?offSet=${vendorState.vendorRelationFilter.offSet}`;
    URL += `&limit=${vendorState.vendorRelationFilter.limit}`;
    URL += `&productName=${vendorState.vendorRelationFilter.productName}`;
    URL += `&supplierItemName=${vendorState.vendorRelationFilter.supplierItemName}`;
    URL += `&categoryId=${vendorState.vendorRelationFilter.categoryId}`;
    URL += `&relationType=${vendorState.vendorRelationFilter.relationType}`;


    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendorRelations(res.data.records));
    yield put(
      setVendorRelationFilter({
        field: 'pages',
        value: res.data.pages,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}


function* getVendorPriceLogs({ payload: { id } }) {
  try {
    const vendorState = yield select(getVendor);
    let URL = VENDORS_ENDPOINT;
    URL += `/priceLogs/${id}`
    URL += `?offSet=${vendorState.vendorPriceLogsFilter.offSet}`;
    URL += `&limit=${vendorState.vendorPriceLogsFilter.limit}`;
    URL += `&startDate=${vendorState.vendorPriceLogsFilter.startDate}`;
    URL += `&endDate=${vendorState.vendorPriceLogsFilter.endDate}`;


    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendorPriceLogs(res.data.records));
    yield put(
      setVendorPriceLogsFilter({
        field: 'pages',
        value: res.data.pages,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getVendors() {
  try {
    const vendorState = yield select(getVendor);
    let URL = VENDORS_ENDPOINT;
    URL += `?offSet=${vendorState.filter.offSet}`;
    URL += `&limit=${vendorState.filter.limit}`;
    URL += `&query=${vendorState.filter.query}`;

    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendors(res.data.records));
    yield put(
      setVendorFilter({
        field: 'pages',
        value: res.data.pages,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getVendorsList() {
  try {
    let URL = `${VENDORS_ENDPOINT}/get/list`;
    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendorsList(res.data));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* getVendorsListClient() {
  try {
    let URL = `${VENDORS_ENDPOINT}/get/listClient`;
    const res = yield httpGet(URL);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendorsListClient(res.data));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* addVendor() {
  try {
    const vendorState = yield select(getVendor);
    const vendor = vendorState.vendor;
    const res = yield httpPost(VENDORS_ENDPOINT, vendor);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(emptyVendor());
  } catch (error) {
    yield put(apiError(error));
  }
}

function* deleteVendor({ payload: { id } }) {
  try {
    const res = yield httpDelete(`${VENDORS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }
    console.log('shoud run');
    yield put(fetchVendors());
  } catch (error) {
    yield put(apiError(error));
  }
}

function* editVendor({ payload: { id } }) {
  try {
    const res = yield httpGet(`${VENDORS_ENDPOINT}/${id}`);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }

    yield put(setVendor({ field: 'food_format', value: res.data.food_format }));
    yield put(
      setVendor({ field: 'vendor_email', value: res.data.vendor_email })
    );
    yield put(setVendor({ field: 'vendor_name', value: res.data.vendor_name }));
    yield put(
      setVendor({
        field: 'customer_department',
        value: res.data.customer_department,
      })
    );
    yield put(
      setVendor({ field: 'vendor_phone', value: res.data.vendor_phone })
    );
    yield put(
      setVendor({
        field: 'supplier_username',
        value: res.data.supplier_username,
      })
    );
    yield put(
      setVendor({
        field: 'supplier_password',
        value: res.data.supplier_password,
      })
    );
    yield put(setVendor({ field: 'distributor', value: res.data.distributor }));
    yield put(
      setVendor({ field: 'ordering_url', value: res.data.ordering_url })
    );
    yield put(
      setVendor({
        field: 'transportation_cost',
        value: res.data.transportation_cost,
      })
    );
    yield put(
      setVendor({
        field: 'minimum_order_amount',
        value: res.data.minimum_order_amount,
      })
    );
    yield put(
      setVendor({
        field: 'vendor_rebate_type',
        value: res.data.vendor_rebate_type,
      })
    );
    yield put(
      setVendor({ field: 'rebate_price', value: res.data.rebate_price })
    );
    yield put(
      setVendor({
        field: 'miscellaneous_cost',
        value: res.data.miscellaneous_cost,
      })
    );
    yield put(
      setVendor({
        field: 'enable_deliver_date',
        value: res.data.enable_deliver_date,
      })
    );
    yield put(
      setVendor({
        field: 'minimum_order_case',
        value: res.data.minimum_order_case,
      })
    );
    yield put(
      setVendor({
        field: 'customer_number',
        value: res.data.customer_number,
      })
    );
    yield put(
      setVendor({
        field: 'is_hide_slave',
        value: res.data.is_hide_slave,
      })
    );
    yield put(
      setVendor({
        field: 'ignore_zeros',
        value: res.data.ignore_zeros,
      })
    );
  } catch (error) {
    yield put(apiError(error));
  }
}

function* updateVendor({ payload: { id } }) {
  try {
    const vendorState = yield select(getVendor);
    const vendor = vendorState.vendor;
    const res = yield httpPut(`${VENDORS_ENDPOINT}/${id}`, vendor);
    console.log(res);
    if (res.status !== 200) {
      yield put(apiError(res.data.error));
      return false;
    }
  } catch (error) {
    yield put(apiError(error));
  }
}

const getVendor = (state) => state.Vendor;

export function* watchgetVendors() {
  yield takeEvery(GET_VENDORS, getVendors);
}

export function* watchgetVendorRelations() {
  yield takeEvery(GET_VENDOR_RELATIONS, getVendorRelations);
}

export function* watchgetVendorsList() {
  yield takeEvery(GET_VENDORS_LIST, getVendorsList);
}

export function* watchgetVendorsListClient() {
  yield takeEvery(GET_VENDORS_LIST_CLIENT, getVendorsListClient);
}

export function* watchAddVendor() {
  yield takeEvery(ADD_VENDOR, addVendor);
}

export function* watchDeleteVendor() {
  yield takeEvery(DELETE_VENDOR, deleteVendor);
}

export function* watchEditVendor() {
  yield takeEvery(EDIT_VENDOR, editVendor);
}

export function* watchUpdateVendor() {
  yield takeEvery(UPDATE_VENDOR, updateVendor);
}

export function* watchGetVendorPriceLogs() {
  yield takeEvery(GET_VENDOR_PRICE_LOGS, getVendorPriceLogs);
}

function* vendorSaga() {
  yield all([
    fork(watchgetVendors),
    fork(watchAddVendor),
    fork(watchDeleteVendor),
    fork(watchEditVendor),
    fork(watchUpdateVendor),
    fork(watchgetVendorsList),
    fork(watchgetVendorRelations),
    fork(watchGetVendorPriceLogs),
    fork(watchgetVendorsListClient)
  ]);
}

export default vendorSaga;
